<template>
    <div>
        <template v-if="!eventLoading && event">
            <v-container v-if="event.header_image" fluid :style="`background: #f2f4f5`"
                         :class="$vuetify.breakpoint.smAndDown ?'pa-0' : 'py-0'">
                <v-row justify="center" no-gutters>
                    <v-col cols="12" md="10" lg="8" xl="6" class="pa-0">
                        <v-img :src="event.header_image"/>
                    </v-col>
                </v-row>
            </v-container>
          <router-view></router-view>
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
    import gql from 'graphql-tag';


    export default {
        name: 'Event',
        props: {
            url: String,
        },
        mounted ()
        {
            let url = this.url;
          this.setEventLoading(true)
            this.$apollo.query( {
                query: gql`
                    query eventsShow($url: String!){
                        eventsShow(url: $url) {
                            id
                            redirect_url
                            rooms {
                                id
                                title
                                start
                                end
                                preview_image
                            }
                            sponsors {
                                advanced
                                name
                                file
                                link
                                description
                                downloads_heading
                                contacts_heading
                                downloads {
                                    name
                                    file
                                }
                                contacts {
                                    heading
                                    text
                                }
                            }
                            posters {
                                id
                                title
                                pdf
                                thumbnail
                                author
                                email
                            }
                            language
                            title
                            description
                            sponsor_heading
                            sponsors_show_name
                            sponsors_in_lobby
                            display_lobby
                            html_code
                            start
                            end
                            logo
                            header_image
                            primary_color
                        }
                }`,
                variables: {
                    url: url,
                },
              fetchPolicy: "network-only"
            } ).then( ( { data } ) =>
            {
                if ( data )
                {
                    if(data.eventsShow && data.eventsShow.redirect_url) {
                        window.location.href = data.eventsShow.redirect_url;
                    }
                    this.updateEvent( data.eventsShow );
                }
            } ).finally(()=>{this.setEventLoading(false)});
        },
        computed: {
            ...mapState( ['event', 'eventLoading'] ),
            ...mapGetters( ['dark'] ),
        },
        methods: {
          ...mapActions( ['updateEvent'] ),
          ...mapMutations( ['setEventLoading'] ),
        },
    };
</script>

<style scoped>
</style>